<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">View Report</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <ReportTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import ReportTable from "../../../components/Kleyton/Tables/Report/RPT/ReportTable";

export default {
  name: "Report",
  page: {
    title: "View Report Details",
    meta: [{ name: "Single Report", content: window.__env.app.description }]
  },
  components: {
    ReportTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "View Report",

      items: [
        {
          text: "Report ",
          href: "/"
        },
        {
          text: "View Report",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
